/**
 * Front-end behavior for Stacked Assets.
 */
export class StackedAssetsFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		this.root.querySelectorAll( '[data-block="stacked-assets"]' ).forEach( ( el ) => {
			el.classList.add( 'stacked-assets-enhanced' );
		} );
	}
}
